export default function NotFound() {
  return (
    <div className="tw-min-h-[60vh] tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-max-w-md tw-w-full tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-8 tw-text-center">
        <h1 className="tw-text-6xl tw-font-bold tw-mb-2 tw-text-blue-700">
          404
        </h1>
        <h2 className="tw-text-2xl tw-font-semibold tw-text-gray-800 tw-mb-4">
          Page non trouvée
        </h2>
        <p className="tw-text-gray-600 tw-mb-6">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="tw-space-y-3">
          <button
            onClick={() => window.location.href = '/'}
            className="tw-w-full tw-px-4 tw-py-2 tw-text-white tw-font-medium tw-rounded-md tw-transition-colors tw-bg-blue-700 hover:tw-bg-blue-800"
          >
            Retour à l'accueil
          </button>
          <button
            onClick={() => window.history.back()}
            className="tw-w-full tw-px-4 tw-py-2 tw-bg-gray-200 tw-text-gray-700 tw-font-medium tw-rounded-md hover:tw-bg-gray-300 tw-transition-colors"
          >
            Retour à la page précédente
          </button>
        </div>
      </div>
    </div>
  );
}
